//引入路由
import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/pages/Home'
import About from '@/pages/About'
import History from '@/pages/History'
import Product from '@/pages/Product'
import News from '@/pages/News'
import Contact from '@/pages/Contact'
import NewsDetails from '@/pages/News/NewsDetails'
import NewsList from '@/pages/News/NewsList'
import ProductList from '@/pages/Product/ProductList'
import ProductDetails from '@/pages/Product/ProductDetails'
import index from '@/pages/index/index.vue' //首页
import MediaReport from '@/pages/MediaReport/index.vue' //媒体报道
import ContactUs from '@/pages/contactUs/index.vue'//联系我们
import AboutUs from '@/pages/aboutUs'//关于元羿
import Pipeline from '@/pages/pipeline' //管线科学
import EcoPartner from '@/pages/ecoPartner'
import JoinUs from '@/pages/contactUs/joinUs.vue'
import MediaDetails from '@/pages/mediaDetails/index.vue'
import JobDetails from '@/pages/contactUs/jobDetails.vue'
import legalNotice from '@/pages/legalNotice/index.vue'
export default createRouter({
  // mode: 'history',
  history: createWebHistory('/'),//HTML模式——在路径中不会出现“#”，
  base: './',
  routes: [{
    name: "home",
    path: '/home',
    component: Home,
  },
  {
    name: "index",
    path: "/",
    component: index
  },
  {
    name: "about",
    path: '/about',
    component: About
  },
  {
    name: "history",
    path: '/history',
    component: History
  },
  {
    name: "product",
    path: '/product',
    component: Product,
    children: [{
      path: "productlist",
      component: ProductList
    }, {
      name: "productdetails",
      path: "productdetails",
      component: ProductDetails
    },


    //重定向，项目跑起来时，访问/product，会定位到/product/productlist组件
    {
      path: '/',
      redirect: "/"
    }]
  },
  {
    name: "news",
    path: '/news',
    component: News,
    children: [{
      path: "newsdetails",
      component: NewsDetails
    },
    {
      path: "newslist",
      component: NewsList
    },
    //重定向，项目跑起来时，访问/news，会定位到/news/newslist组件
    {
      path: '/news',
      redirect: "/news/newslist"
    }
    ]
  },
  {
    name: "contact",
    path: '/contact',
    component: ContactUs
  },
  {
    name: "joinUs",
    path: '/joinUs',
    component: JoinUs
  },
  {
    name: "jobDetails",
    path: '/jobDetails',
    component: JobDetails
  },
  
  {
    name: "report",
    path: '/report',
    component: MediaReport
  },
  {
    name: "aboutUs",
    path: '/aboutUs',
    component: AboutUs,
  },
  {
    name: "pipeline",
    path: '/pipeline',
    component: Pipeline
  },

  
   {
     name: "eco",
     path: '/eco',
     component: EcoPartner
  },    
  
  {
    name: "mediaDetails",
    path: '/mediaDetails',
    component: MediaDetails
 },    
 {
  name: "legalNotice",
  path: '/legalNotice',
  component: legalNotice
  },
  //重定向，项目跑起来时，访问/，会定位到home组件
  {
    path: '/',
    redirect: "/index"
  }
  ],
  //路由切换时自动滚动到顶部
  scrollBehavior () {
    return { top: 0 }
  },
})